<form [formGroup]="financeiroForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Dados Financeiros do Empreendimento (R$)</h2>
      <div class="form-group">
        <span class="icon checklist-cash"></span>
        <div class="inputs">
          <label for="despesasOperacionaisNegocio">Despesas operacionais do negócio
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Mão de obra, serviços, aluguel, água, luz, telefone, transporte e impostos pagos mensalmente.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="despesasOperacionaisNegocio"
            formControlName="despesasOperacionaisNegocio"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="despesasAlimentacaoFamilia">Despesas com alimentação da família
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Supermercado, açougue, mercearia, padaria, etc.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="despesasAlimentacaoFamilia"
            formControlName="despesasAlimentacaoFamilia"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="despesasAluguelResidencial">Despesas com aluguel residencial
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Incluir condomínio e outras despesas referente ao aluguel (se existir).'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="despesasAluguelResidencial"
            formControlName="despesasAluguelResidencial"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="despesasVestuarioFamilia">Despesas com vestuário na família
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Gastos com roupas, cama, mesa e banho.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="despesasVestuarioFamilia"
            formControlName="despesasVestuarioFamilia"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="despesasEducacaoFamilia">Despesas com educação na família
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Gasto com jardim, escola de filhos, faculdade de filho ou pessoal, livros, cursos técnicos.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="despesasEducacaoFamilia"
            formControlName="despesasEducacaoFamilia"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="despesasServicosDiversos">Despesas com água, luz, telefone e internet na família</label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="despesasServicosDiversos"
            formControlName="despesasServicosDiversos"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="despesasMoveisEletrodomesticos">Despesas com prestações de móveis e eletrodomésticos e outros
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="despesasMoveisEletrodomesticos"
            formControlName="despesasMoveisEletrodomesticos"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="somaRendaFamiliar">Soma da renda familiar
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Salários do conjuge, rendas adicionais que ajudam nas despesas da família.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="somaRendaFamiliar"
            formControlName="somaRendaFamiliar"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="somaCaixaBanco">Soma valor em caixa e bancos hoje
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Verificar fisicamente o quanto há no caixa ou veja o extrato bancário.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="somaCaixaBanco"
            formControlName="somaCaixaBanco"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="contasReceber">Contas a receber
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Somar o valor de todo o fiado/caderneta que o cliente tem a receber e subtrair do que já foi perdido.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="contasReceber"
            formControlName="contasReceber"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="estoque">Estoque
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Somar o valor de todo o estoque, preferencialmente por contagem física das peças - verificação visual.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="estoque"
            formControlName="estoque"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="veiculos">Veículos
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Carros ou motos que são utilizados pelo negócio.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="veiculos"
            formControlName="veiculos"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="maquinasEquipamentos">Máquinas e equipamentos
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Utilizado pelo negócio.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="maquinasEquipamentos"
            formControlName="maquinasEquipamentos"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="dividaFornecedores">Dívidas com fornecedores
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Somar o valor dos boletos a vencer, cheques pré-datados, faturas de cartões ou pedidos a pagar.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="dividaFornecedores"
            formControlName="dividaFornecedores"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="contasPagar">Contas a pagar em geral
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Somar os boletos de água, luz, telefone, aluguel, folha de pagamento, frete, combustível, e impostos.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="contasPagar"
            formControlName="contasPagar"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>

    </div>
  </div>
</form>

<app-botao-navegacao
(previous)="onClickPrevious()"
(next)="onClickNext()"
[previousShow]="true"
[nextShow]="true"
[nextEnabled]="financeiroForm.valid">
</app-botao-navegacao>
